export default function TestsDirective() {
  return {
    template: require('./tests.html'),
    scope: {
      assessmentId: '=',
      tests: '=',
      isEditable: '=',
      fromDialog: '=',
    },
    controller: 'TestsController',
    controllerAs: 'testsVM',
    bindToController: true,
    replace: true,
  };
}
